var React = require('react');
var ReactNative = require('react-native');

var Animated = require('./wrappers/Animated')

var Globals = require('./Globals');
var NetworkManager = require('./NetworkManager.js');
var ModelConstants = require('./constants/ModelConstants.js');
var ReUpButton = require('./ReUpButton.js');
var ReUpScrollView = require('./ReUpScrollView.js');
var ReUpText = require('./ReUpText');
var PlatformConstants = require('./constants/PlatformConstants');
import Icon from './wrappers/ReUpIcon';
var NumericalInput = require('./NumericalInput.js');

var {
  AppRegistry,
  Text,
  View,
  Image,
  ScrollView,
  StyleSheet,
} = ReactNative;

var CreditInput = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      appManager : null,
      extras : {}
    }
  },

  getInitialState : function()
  {
    var locManager = this.props.appManager.getLocalizationManager();
    return {
      layout : this.props.initialLayout,
      chargeText : locManager.localizedStringForKeyAndParams("CHECK_IN_ADD_STATEMENT", ["0"], "Add - 0 points"),
      campaigns : [],
      useCreditCampaign : null,
      referCampaign : null,
      checkInCampaign : null,
      transferLoyaltyCampaign : null,
    }
  },

  componentDidMount : function()
  {
  },

  didUpdate : function(data)
  {
    if( typeof data.Campaigns !== 'undefined' )
    {
      var useCreditCampaign = null;
      var referCampaign = null;
      var checkInCampaign = null;
      var transferLoyaltyCampaign = null;
      for( var i = 0; i < data.Campaigns.length; i++ )
      {
        var campaign = data.Campaigns[i];
        if( campaign.Type == "UseCredit" ) useCreditCampaign = JSON.parse(campaign.CampaignBlob);
        if( campaign.Type == "Referral" ) referCampaign = JSON.parse(campaign.CampaignBlob);
        if( campaign.Type == "Checkin" || campaign.Type == "CheckIn" ) checkInCampaign = JSON.parse(campaign.CampaignBlob);
        if( campaign.Type == "TransferLoyalty" ) transferLoyaltyCampaign = JSON.parse(campaign.CampaignBlob);
      }
      // var useCreditCampaign =  {Type: "UseCredit", DollarsPerPoint: 1};
      // var referCampaign =  {Type: "Referral", ReferrerPoints: 10, RefereePoints: 10};
      // var checkInCampaign =  {Type: "Checkin", DollarsPerPoint: 2, FixedPoints: 0, AssignPoints: 0/1};
      // var transferLoyaltyCampaign =  {Type: "TransferLoyalty", Identifier: ["p", "e"]};

      this.setState({
        campaigns:data.Campaigns,
        useCreditCampaign:useCreditCampaign,
        referCampaign:referCampaign,
        checkInCampaign:checkInCampaign,
        transferLoyaltyCampaign:transferLoyaltyCampaign
      });
    }
  },

  submitPressed: function()
  {
    var thisThing = this;
    var appActions = this.props.appActions;
    var appManager = this.props.appManager;
    var locManager = appManager.getLocalizationManager();
    var pointsString = this.refs.numInput.stringPointValue();
    var dollarsAmount = this.refs.numInput.dollarsAmount();
    var pointsAmount = this.refs.numInput.pointsAmount();
    var processingSpinner  = locManager.localizedStringForKey("PAYING_HUD");
    var checkinAmount = dollarsAmount;
    if( this.state.checkInCampaign != null && (typeof this.state.checkInCampaign.AssignPoints !== 'undefined') && this.state.checkInCampaign.AssignPoints != 0 )
    {
      checkinAmount = pointsAmount;
    }
    var msgLocalized = locManager.localizedStringForKeyAndParams("ADD_STATEMENT", [pointsString]);
    appActions.showLocalizedAlert("ASSIGN_POINTS_ALERT_TITLE", msgLocalized, ["NO_ALERT_BUTTON","YES_ALERT_BUTTON"], [function()
    {
      appActions.hideAlert();
    },function()
    {
      appActions.hideAlert();
      appActions.setSpinnerShown(true, processingSpinner);
      NetworkManager.vendorCheckIn(appManager, thisThing.props.extras.userID, checkinAmount, thisThing.props.extras.userType, thisThing.props.extras.hash, function(data)
      {
        appActions.setSpinnerShown(false);
        var extras = data;
        extras.success = true;
        extras.isCheckin = true;
        extras.scanner = thisThing.props.extras.scanner;;
        appActions.requestFeatureName("TransactionResult", extras);
      }, function(data)
      {
        appActions.setSpinnerShown(false);
        var extras = data;
        extras.success = false;
        extras.scanner = thisThing.props.extras.scanner;
        appActions.requestFeatureName("TransactionResult", extras);
      }, function(data)
      {
        appActions.setSpinnerShown(false);
        appActions.showNetworkErrorAlert(appActions.hideAlert, appActions.hideAlert)
      })
    }], function(){}, false, false, 20, 18, 20)
  },

  render: function()
  {
    var appManager = this.props.appManager;
    var locManager = appManager.getLocalizationManager();
    var thisThing = this;
    var generalColor = appManager.getColorForKey("GeneralColor");
    var dollarsPerPoint = 0;
    var isAssignPoints = false;
    if( this.state.checkInCampaign != null && this.state.checkInCampaign.DollarsPerPoint != 0 )
    {
      dollarsPerPoint = this.state.checkInCampaign.DollarsPerPoint;
    }
    else if( this.state.checkInCampaign != null && (typeof this.state.checkInCampaign.AssignPoints !== 'undefined') && this.state.checkInCampaign.AssignPoints != 0 )
    {
      isAssignPoints = true;
    }
    var inputHeight = 400;
    var inputWidth = this.state.layout.width > 620 ? 600 : this.state.layout.width-20;
    var buttonWidth = this.state.layout.width-20;
    var cancelButton = locManager.localizedStringForKey("CANCEL_BUTTON");
    return (
      <View style={[styles.container, {backgroundColor:generalColor}]}>
        <ReUpScrollView responder={this}>
          <View style={{flexDirection:'column', alignItems:'stretch'}}>

            <View style={{flex:1, flexDirection:'row'}}>
              <View style={{flex:1}} />
              {
                isAssignPoints ?
                <NumericalInput ref="numInput" style={{height:inputHeight, width:inputWidth, marginTop:20}} isCheckin={true} appManager={this.props.appManager} valueChanged={(newValue,newStringValue)=>{thisThing.setState({chargeText:thisThing.localizedStringForKey("CHECK_IN_ADD_STATEMENT", [newStringValue])})}}
                displayPoints={true}>
                  </NumericalInput>
                  :
                  <NumericalInput ref="numInput" style={{height:inputHeight, width:inputWidth, marginTop:20}} isCheckin={true} appManager={this.props.appManager} valueChanged={(newValue,newStringValue)=>{thisThing.setState({chargeText:thisThing.localizedStringForKey("CHECK_IN_ADD_STATEMENT", [newStringValue])})}}
                    dollarsPerPoint={dollarsPerPoint}>
                  </NumericalInput>
              }
              <View style={{flex:1}} />
            </View>
            <ReUpButton style={[styles.button,{margin:10, width:buttonWidth}]}
              appManager={appManager}
              text={this.state.chargeText}
              onPress={() =>
              {
                thisThing.submitPressed();
              }}
              />

            <ReUpButton isSecondary={true} style={[styles.button,{margin:10, width:buttonWidth}]}
              appManager={appManager}
              text={cancelButton}
              onPress={() =>
              {
                thisThing.props.appActions.requestPop();
                if( typeof thisThing.props.extras.scanner !== 'undefined' && thisThing.props.extras.disableAutoScannerLaunch != true )
                {
                  setTimeout(function()
                  {
                    thisThing.props.extras.scanner.scan();
                  },300)
                }
              }}
              />

          </View>
        </ReUpScrollView>
      </View>
    );
  }
});

var styles = StyleSheet.create({
  container:{
    flex: 1,
    alignItems: 'stretch',
    flexDirection: 'column',
    backgroundColor:'white'
  },
  actionBarSpacer: {
    height:0,//Globals.ACTION_BAR_HEIGHT,
  },
  image: {
    position: 'absolute',
  },
});


CreditInput.dataDependencies = ["Campaigns"]

module.exports = CreditInput;



// WEBPACK FOOTER //
// ./src/CheckInInput.js